import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { LeftNavigationStyled } from "../styles/LeftPanel.style";
import { useAuth } from "../../context/AuthProvider";
import { localStorage } from "../../helpers/localStorage";

import { useSignOut } from "../../hooks";
import { getUserRoles, getRefreshToken } from "../../helpers/constants";
import PasswordSharpIcon from "@mui/icons-material/PasswordSharp";

interface LeftPanelProps {}

const LeftPanel: React.FC<LeftPanelProps> = ({}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const currPath = location.pathname;

  const { handleLogout } = useAuth();
  let roles = getUserRoles();

  const {
    removeAuthToken,
    removeRefreshToken,
    removeUserId,
    removeUserFirstName,
    removeUserLastName,
    removeUserRoles,
    removeClientsTable,
    removeClientsConfigTable,
    removeFileListTable,
  } = localStorage;

  const { mutate: postSignOut, isPending, isSuccess } = useSignOut();

  const handleOnclick = (route: any) => {
    console.log("submit", route);
    navigate(route);
  };

  const PostSignOutSuccess = (result: any) => {
    console.log("result", result);
    if (result.message == "Successful") {
      removeRefreshToken();
      removeAuthToken();
      removeUserRoles();
      navigate("/");
    }
  };

  const PostSignOutError = (error: any) => {
    console.log("error", error);
    removeRefreshToken();
    removeAuthToken();
    removeUserRoles();
    navigate("/");
  };

  const logoutUser = () => {
    handleLogout();
    removeUserId();
    removeUserFirstName();
    removeUserLastName();
    removeClientsTable();
    removeClientsConfigTable();
    const reqBody: any = {
      refreshToken: getRefreshToken(),
    };
    postSignOut(reqBody, {
      onSuccess: PostSignOutSuccess,
      onError: PostSignOutError,
    });
  };

  return (
    <LeftNavigationStyled>
      <nav aria-label="main mailbox folders">
        <List>
          <ListItem disablePadding>
            {(roles.includes("admin") || roles.includes("Administrator")) && (
              <ListItemButton
                selected={currPath === "/clients"}
                color={currPath === "/clients" ? "primary" : undefined}
                onClick={() => handleOnclick("/clients")}
              >
                <ListItemIcon>
                  <PeopleAltOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary="OUR Clients" />
              </ListItemButton>
            )}
          </ListItem>

          {(roles.includes("admin") || roles.includes("Administrator")) && (
            <ListItem disablePadding>
              <ListItemButton
                selected={currPath === "/clients-platforms"}
                color={
                  currPath === "/clients-platforms" ? "primary" : undefined
                }
                onClick={() => handleOnclick("/clients-platforms")}
              >
                <ListItemIcon>
                  <ManageAccountsOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary="Client Platforms" />
              </ListItemButton>
            </ListItem>
          )}

          {(roles.includes("admin") || roles.includes("Administrator")) && (
            <ListItem disablePadding>
              <ListItemButton
                selected={currPath === "/credentials-configurations"}
                color={
                  currPath === "/credentials-configurations "
                    ? "primary"
                    : undefined
                }
                onClick={() => handleOnclick("/credentials-configurations")}
              >
                <ListItemIcon>
                  <PasswordSharpIcon />
                </ListItemIcon>
                <ListItemText primary="CREDENTIAL CONFIG" />
              </ListItemButton>
            </ListItem>
          )}

          <ListItem disablePadding>
            <ListItemButton
              selected={currPath === "/file-list"}
              color={currPath === "/file-list" ? "primary" : undefined}
              onClick={() => handleOnclick("/file-list")}
            >
              <ListItemIcon>
                <FileUploadOutlinedIcon />
              </ListItemIcon>
              <ListItemText primary="File LIST" />
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding className="top-border">
            <ListItemButton onClick={() => logoutUser()}>
              <ListItemIcon>
                <LogoutOutlinedIcon />
              </ListItemIcon>
              <ListItemText primary="Sign Out" />
            </ListItemButton>
          </ListItem>
        </List>
      </nav>

      <Box className="CopyRightText">
        © {new Date().getFullYear()} 2060 Digital. <br />
        All Rights Reserved.
      </Box>
    </LeftNavigationStyled>
  );
};

export default LeftPanel;
